export enum ReportDisplayType {
    TABLE = 'TABLE',
    PIE_CHART = 'PIE_CHART',
    BAR_CHART = 'BAR_CHART'
}
